var map = {
	"./debate/4-1.jpg": 60566,
	"./debate/4-10.png": 24742,
	"./debate/4-2.jpg": 7500,
	"./debate/4-3.jpg": 74841,
	"./debate/4-4.jpg": 39371,
	"./debate/4-5.jpg": 23833,
	"./debate/4-6.png": 18130,
	"./debate/4-7.png": 41905,
	"./debate/4-8.png": 72385,
	"./debate/4-9.png": 37412,
	"./itsMe/2-1.png": 70520,
	"./itsMe/2-10.png": 89601,
	"./itsMe/2-11.png": 59488,
	"./itsMe/2-12.png": 95441,
	"./itsMe/2-13.png": 58993,
	"./itsMe/2-14.png": 65326,
	"./itsMe/2-15.png": 66725,
	"./itsMe/2-16.png": 99776,
	"./itsMe/2-2.png": 4555,
	"./itsMe/2-3.png": 45958,
	"./itsMe/2-4.png": 25118,
	"./itsMe/2-5.png": 1127,
	"./itsMe/2-6.png": 98679,
	"./itsMe/2-7.png": 55450,
	"./itsMe/2-8.png": 26576,
	"./itsMe/2-9.png": 57280,
	"./junior/3-1.png": 49078,
	"./junior/3-10.jpg": 32733,
	"./junior/3-11.jpg": 34910,
	"./junior/3-2.png": 49067,
	"./junior/3-3.png": 21664,
	"./junior/3-4.png": 93440,
	"./junior/3-5.png": 94551,
	"./junior/3-6.png": 80105,
	"./junior/3-7.png": 49573,
	"./junior/3-8.jpg": 50971,
	"./junior/3-9.jpg": 99345,
	"./phonics/1-1.png": 728,
	"./phonics/1-2.png": 91904,
	"./phonics/1-3.png": 74844,
	"./phonics/1-4.png": 59175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84378;